// extracted by mini-css-extract-plugin
export default {"root":"GoogleCalendarSection_root__j3ClU","iframe":"GoogleCalendarSection_iframe__U5lBf"};